module.exports = __webpack_public_path__ + "static/media/14.ace176d7.jpg";